/*
 * --------------------------------------------------------------------------- *
 * File: Collateral.js                                                         *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext, useEffect, useState } from "react";
import DataForm from "../data/dataform";
import { Cloud } from "../main/cloud";
import Constants from "../main/constants";
import { nanoid } from "nanoid";
import { AppContext } from "../main/context";
import { getDataTypeDetails, getSampleValue } from "../data/datatypeutils";
import { ValidationManager } from "../data/validations";

const Collateral = () => {
  const { setShowNow, collateral, setCollateral, customerId } = useContext(AppContext);
  const [data, setData] = useState(collateral?.id ? collateral : getSampleValue(collateral?.type));

  useEffect(() => {
    setData(collateral?.id ? collateral : getSampleValue(collateral?.type));
  }, [collateral]);

  const submit = async () => {
    if (!collateral.id) data.id = nanoid();
    data.type = collateral.type;
    data.customerId = customerId;
    await Cloud.post(`${Constants.apiBaseUrl}`, {
      action: collateral.id ? "UPDATE_COLLATERAL" : "ADD_COLLATERAL",
      data,
    });
    setShowNow(Constants.SHOW_NOW_COLLATERALS);
  };

  if (collateral?.type) {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <h1>{getDataTypeDetails(collateral.type).name}</h1>
            <DataForm
              structure={getDataTypeDetails(collateral.type).structure}
              data={data}
              title=""
              description={getDataTypeDetails(collateral.type).description}
              onChange={setData}
              onSubmit={submit}
              validation={new ValidationManager()}
            />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="jumbotron vertical-center">
        <div className="container">
          <div className="row">
            <div className="col-12 center">
              <button
                className="btn btn-outline-primary m-1"
                onClick={() => {
                  setCollateral({ type: "CollateralCommercial" });
                }}
              >
                New Commercial Collateral
              </button>
              <button
                className="btn btn-outline-primary m-1"
                onClick={() => {
                  setCollateral({ type: "CollateralResidential" });
                }}
              >
                New Residential Collateral
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Collateral;
